import { Injectable } from '@angular/core';
import { DataService } from '../../architecture/data.service';
import { Result } from '../../architecture/envelopes';
import { HttpParams } from '@angular/common/http';
import { WaiverRequestFilter } from 'src/app/shared/models/waiverrequestFilter.model';

@Injectable({ providedIn: 'root' })
export class WaiverRequestService {
    constructor(private dataService: DataService) { }

    public get(page: number, order: string, orderT: string, filter: WaiverRequestFilter) {
        let params = new HttpParams()
            .set('filter.page', page.toString())
            .set('filter.entity.client', filter.clientId)
            .set('filter.entity.id', filter.id)
            .set('filter.orderByField', order)
            .set('filter.orderBy', orderT);

        return this.dataService.get<Result<any>>("request/waiver", params);
    }

    public reactivate(ids: any) {
        return this.dataService.post<Result<any>>("request/waiver/reactivate", ids);
    }
}
